import { render, staticRenderFns } from "./ParkingSpaceOwner.vue?vue&type=template&id=98595a6c&"
import script from "./ParkingSpaceOwner.vue?vue&type=script&lang=js&"
export * from "./ParkingSpaceOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports